import React from 'react';
import { FETCH_STATUSES } from './constants';
import Loader from '../../components/Loader';
import ErrorPlaceHolder from './ErrorPlaceholder';

const getFetchPlaceholder = (
  data: any,
  status: keyof typeof FETCH_STATUSES,
  error?: Error,
  options: {
    onError: string;
    onEmpty: string;
    handleEmpty: boolean;
  } = {
    onError: 'Failed to fetch data: unexpected error',
    onEmpty: 'Failed to fetch data: empty response',
    handleEmpty: true
  }
) => {
  switch (status) {
    case FETCH_STATUSES.INIT:
      return <div />;
    case FETCH_STATUSES.IN_PROGRESS:
      return <Loader />;
    case FETCH_STATUSES.FAILED:
      return <ErrorPlaceHolder />;
    default:
    // Do nothing on success
  }

  if (!data && options.handleEmpty) {
    return <ErrorPlaceHolder />;
  }
};

export default getFetchPlaceholder;
